// extracted by mini-css-extract-plugin
export default {"middlePaneWrapper":"MilestoneCreate-module__middlePaneWrapper--bE3hO"};